var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "indicator-style6" }, [
    _c("div", { staticClass: "indicator-style-item-content" }, [
      _c(
        "div",
        {
          staticClass: "indicator-style-item bi_dashboard_text_overflow",
          staticStyle: {
            "margin-bottom": "4px",
            "line-height": "1.5",
            "font-weight": "700",
            "text-align": "center",
          },
          attrs: { title: _vm.info.rowValue },
        },
        [_vm._v("\n            " + _vm._s(_vm.info.rowValue) + "\n        ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "jzliu-cli-bi-engine-list-content" }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "align-items": "center",
              "justify-content": "center",
            },
          },
          [
            _vm.chartData.styleConfig.commongConfig.indicatorIcon
              ? _c("style-icon", {
                  staticStyle: {
                    width: "45px",
                    height: "45px",
                    "margin-right": "6px",
                  },
                  attrs: {
                    chartData: _vm.chartData,
                    rowValue: _vm.info.rowValue,
                    idx: _vm.idx,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "bi_dashboard_text_overflow",
                attrs: { title: _vm.info.measureName },
              },
              [_vm._v(_vm._s(_vm.info.measureName))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "bi_dashboard_text_overflow",
            staticStyle: { "font-size": "28px", "font-weight": "700" },
            attrs: { title: _vm.transferWhiteVal(_vm.info.measureValue) },
          },
          [_vm._v(_vm._s(_vm.transferWhiteVal(_vm.info.measureValue)))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }